(() => {
  const CART_URL_RE = /\/cart(?:$|[?#])/;
  const HOME_BADGE_CLASS = 'absolute top-1.5 right-1.5 bg-[#7874F8] text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-bold';
  const PDP_BADGE_CLASS = 'absolute -top-0.5 -right-0.5 bg-[#7874F8] text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center';

  function isAxosCartLink(link) {
    const href = link.getAttribute('href') || '';
    if (href !== '/cart' && !CART_URL_RE.test(href)) return false;
    return Boolean(
      link.querySelector('.lucide-shopping-bag') ||
      link.querySelector('[data-axos-cart-count]') ||
      link.innerHTML.includes('bg-[#7874F8]')
    );
  }

  function badgeClassFor(link) {
    return link.className && String(link.className).includes('w-10') ? HOME_BADGE_CLASS : PDP_BADGE_CLASS;
  }

  function findBadge(link) {
    return link.querySelector('[data-axos-cart-count], span[class*="bg-[#7874F8]"], span[class*="bg-\\[\\#7874F8\\]"]');
  }

  function updateBadge(count) {
    const itemCount = Number(count) || 0;
    document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach((link) => {
      if (!isAxosCartLink(link)) return;
      let badge = findBadge(link);
      if (itemCount <= 0) {
        if (badge) badge.remove();
        link.setAttribute('aria-label', 'Cart');
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = badgeClassFor(link);
        link.appendChild(badge);
      }
      badge.dataset.axosCartCount = '';
      badge.textContent = itemCount > 99 ? '99+' : String(itemCount);
      badge.setAttribute('aria-hidden', 'true');
      link.setAttribute('aria-label', `Cart, ${itemCount} item${itemCount === 1 ? '' : 's'}`);
    });
  }

  async function refreshCartBadge() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      updateBadge(cart.item_count);
    } catch (_) {
      // Keep the existing header state if Shopify cart JSON is unavailable.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartBadge, { once: true });
  } else {
    refreshCartBadge();
  }
  window.addEventListener('pageshow', refreshCartBadge);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshCartBadge();
  });
  document.addEventListener('click', (event) => {
    if (event.target && event.target.closest && event.target.closest('[data-axos-home-cart], form[action*="/cart/add"], a[href*="/cart/"]')) {
      window.setTimeout(refreshCartBadge, 700);
      window.setTimeout(refreshCartBadge, 1800);
    }
  }, true);
})();


// AXOS modern PDP fallback for localized stale product caches
(() => {
  const routes = {
    '/products/ibdassist-pm-night-time-version-of-ibdassist': 'axos-gutsupport-pm-clone',
    '/products/testbalance': 'axos-testbalance-clone',
  };
  const path = window.location.pathname.replace(/\/$/, '');
  const suffix = routes[path];
  if (!suffix) return;
  if (document.querySelector('.axos-modern-pdp')) return;
  if (!document.querySelector('.axos-simple-product')) return;
  if (window.__axosModernPdpFallbackRunning) return;
  window.__axosModernPdpFallbackRunning = true;

  const url = `${path}?view=${encodeURIComponent(suffix)}&axos_modern_pdp_fallback=${Date.now()}`;

  fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } })
    .then((response) => response.ok ? response.text() : Promise.reject(new Error(`HTTP ${response.status}`)))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const modern = doc.querySelector('.axos-modern-pdp');
      const newMain = doc.querySelector('main');
      const currentMain = document.querySelector('main');
      if (!modern || !newMain || !currentMain) return;

      const importedMain = document.importNode(newMain, true);
      currentMain.replaceWith(importedMain);

      importedMain.querySelectorAll('script').forEach((oldScript) => {
        const script = document.createElement('script');
        for (const attr of oldScript.attributes) script.setAttribute(attr.name, attr.value);
        if (oldScript.src) {
          script.src = oldScript.src;
        } else {
          script.text = oldScript.textContent || '';
        }
        document.body.appendChild(script);
      });

      document.documentElement.classList.add('axos-modern-pdp-fallback-applied');
    })
    .catch(() => {
      window.__axosModernPdpFallbackRunning = false;
    });
})();

